/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9 16v-6H5l7-7 7 7h-4v6H9m-4 4v-2h14v2H5z"/>'
  }
})
